import React from 'react';
import {connect} from 'react-redux';
import NhlTeamStackingMarker from 'components/organisms/nhl-team-stacking/services/nhl-team-stacking-marker';
import {DesktopTeamsCombinations} from '../desktop-teams-combinations';
import {NhlLineupStackExtractor} from 'services/nhl-lineup-stack-extractor';
import NhlLegacyTeamStackingMarker from 'components/organisms/nhl-legacy-team-stacking/services/nhl-legacy-team-stacking-marker';

class TeamsCombinations extends DesktopTeamsCombinations {
    getStackedTeams(lineup) {
        let lineupStackExtractor = new NhlLineupStackExtractor(lineup.getOriginalLineup(), NhlTeamStackingMarker);

        const stackedTeams = lineupStackExtractor.getStackedTeams();

        if (!isEmpty(stackedTeams)) {
            return stackedTeams;
        }

        lineupStackExtractor = new NhlLineupStackExtractor(lineup.getOriginalLineup(), NhlLegacyTeamStackingMarker);

        return lineupStackExtractor.getStackedTeams();
    }
}

function mapStatesToProps(state) {
    const {
        lineupsData,
        lineupTeamsCombinations,
    } = state;

    return {
        rawLineups: lineupsData.rawLineups,
        lineupTeamsCombinations,
    };
}

const ComboSummary = connect(mapStatesToProps)(TeamsCombinations);

export {ComboSummary};
